import { NoticeTypeData } from 'lib/enums/NoticeType';
import { DataWithNoticeType } from 'lib/helpers';
import { PublishingSettingModel } from 'lib/model/objects/publishingSettingModel';
import { EOrganization, ESnapshotExists } from 'lib/types';
import {
  disableNonPublishingDays,
  getIsAfterPublishingDeadline,
  isAllowedPublicationDay,
  publishingDayEnumValuesFromDeadlines
} from 'lib/utils/deadlines';

export type shouldDisablePublishingDateParams = {
  day: Date;
  publishingSetting: PublishingSettingModel;
  newspaper: ESnapshotExists<EOrganization>;
};
/**
 * Checks if the given date should be disabled in the confirm schedule step
 */
export const shouldDisablePublishingDate = ({
  day,
  publishingSetting,
  newspaper
}: shouldDisablePublishingDateParams): boolean => {
  const { iana_timezone } = newspaper.data();
  const { deadlines, deadlineOverrides = {} } =
    publishingSetting.modelData ?? {};
  if (!deadlines || !day || !iana_timezone) {
    return true;
  }

  const isNonPublishingDay = disableNonPublishingDays(
    day,
    publishingDayEnumValuesFromDeadlines(deadlines),
    deadlineOverrides
  );

  const adTypeData: DataWithNoticeType = {
    noticeType: NoticeTypeData.other.value
  };

  const isAfterDeadline = getIsAfterPublishingDeadline(
    day,
    deadlines,
    deadlineOverrides,
    iana_timezone,
    adTypeData,
    newspaper
  );

  return (
    isAfterDeadline || !isAllowedPublicationDay(day, null) || isNonPublishingDay
  );
};
